import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class PermissionsService extends EntityService {
  static get entity() {
    return 'additional-permissions';
  }

  static async getUserPermissions(userId, parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({
        auth: true
      }).get(`/users/${userId}/additional-permissions`, { params });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
